"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Key Management API
 * API for managing verifying email addresses on the Socrata platform.  # Signing Up On The Socrata Platform  When a user signs up for the platform, an email containing a token will be sent to the address they signed up with.  New users will not be able to login to the platform or be added as a collaborator on any assets until they first click the link that was emailed to them.  # Changing Emails  When a user wants to change their email address, they can do so if they also provide their current password.  When this is done, an email will be sent to the new email address that contains a token.  An email will also be sent to the user\'s old account letting them know that their email has changed on the platform. This is to protect users whose accounts may have been compromised to let them know of malicious email change attempts. In this case, they can contact Socrata support to reclaim the account if needed.  The email change will be pending and the user will still have their old email address until they click the link that was emailed to their new account. When this link is clicked, the email change is applied.  # Changelog  ## 1.1.0  Change generator enum property naming to `original` for `typescript-fetch` client.  Add missing error codes.  ## 1.0.0  Initial specification.
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailVerificationApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var EmailVerificationApi = /** @class */ (function (_super) {
    __extends(EmailVerificationApi, _super);
    function EmailVerificationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Cancel a pending email change for a user.  If the given user does not have a current pending email change, this endpoint does nothing and responds with an error.  Unless you are a platform administrator, you can only perform this action for the `current` user.
     * Cancel a pending email change
     */
    EmailVerificationApi.prototype.cancelEmailChangeRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/users/current/email_change",
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Cancel a pending email change for a user.  If the given user does not have a current pending email change, this endpoint does nothing and responds with an error.  Unless you are a platform administrator, you can only perform this action for the `current` user.
     * Cancel a pending email change
     */
    EmailVerificationApi.prototype.cancelEmailChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelEmailChangeRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Used to change the current user\'s email address.  When this endpoint is hit, an email will be sent to the new email address containing a link with a token, and an email will be sent to the new email address notifying it of the attempted change. When that link is clicked, the email change will be applied to the user. Until the link is clicked, the user will keep their old email address.
     * Change the current user\'s email
     */
    EmailVerificationApi.prototype.changeEmailRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/users/current/email_change",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ChangeEmailRequestBodyToJSON(requestParameters.changeEmailRequestBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.EmailChangeSuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Used to change the current user\'s email address.  When this endpoint is hit, an email will be sent to the new email address containing a link with a token, and an email will be sent to the new email address notifying it of the attempted change. When that link is clicked, the email change will be applied to the user. Until the link is clicked, the user will keep their old email address.
     * Change the current user\'s email
     */
    EmailVerificationApi.prototype.changeEmail = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeEmailRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the status for a user\'s email verification.  Unless you are a platform administrator, you can only perform this action for the `current` user.
     * Get email verification status
     */
    EmailVerificationApi.prototype.getEmailVerificationStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userIdentifier === null || requestParameters.userIdentifier === undefined) {
                            throw new runtime.RequiredError('userIdentifier', 'Required parameter requestParameters.userIdentifier was null or undefined when calling getEmailVerificationStatus.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/users/{userIdentifier}/email_verification".replace("{" + "userIdentifier" + "}", encodeURIComponent(String(requestParameters.userIdentifier))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.EmailVerificationStatusResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the status for a user\'s email verification.  Unless you are a platform administrator, you can only perform this action for the `current` user.
     * Get email verification status
     */
    EmailVerificationApi.prototype.getEmailVerificationStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEmailVerificationStatusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This will cause the email that contains the verification code to be re-sent to the user.  This will invalidate any previous verification codes that the user has not yet used.
     * Resend the verification email
     */
    EmailVerificationApi.prototype.resendEmailVerificationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userIdentifier === null || requestParameters.userIdentifier === undefined) {
                            throw new runtime.RequiredError('userIdentifier', 'Required parameter requestParameters.userIdentifier was null or undefined when calling resendEmailVerification.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/users/{userIdentifier}/email_verification/resend".replace("{" + "userIdentifier" + "}", encodeURIComponent(String(requestParameters.userIdentifier))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This will cause the email that contains the verification code to be re-sent to the user.  This will invalidate any previous verification codes that the user has not yet used.
     * Resend the verification email
     */
    EmailVerificationApi.prototype.resendEmailVerification = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resendEmailVerificationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Verify a new user\'s email address, or complete an email change request.  Since this endpoint required a token id and a token secret, it does not require authentication.
     * Verify an email
     */
    EmailVerificationApi.prototype.verifyEmailRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userIdentifier === null || requestParameters.userIdentifier === undefined) {
                            throw new runtime.RequiredError('userIdentifier', 'Required parameter requestParameters.userIdentifier was null or undefined when calling verifyEmail.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/email_verification".replace("{" + "userIdentifier" + "}", encodeURIComponent(String(requestParameters.userIdentifier))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.VerifyEmailRequestBodyToJSON(requestParameters.verifyEmailRequestBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Verify a new user\'s email address, or complete an email change request.  Since this endpoint required a token id and a token secret, it does not require authentication.
     * Verify an email
     */
    EmailVerificationApi.prototype.verifyEmail = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifyEmailRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return EmailVerificationApi;
}(runtime.BaseAPI));
exports.EmailVerificationApi = EmailVerificationApi;
